/**
 * Default `notifyOnChangeProps` for React Query hooks.
 * Limits re-renders to only fire when these specific query-state fields change,
 * avoiding unnecessary re-renders on tab-focus refetch.
 */
export const DEFAULT_QUERY_NOTIFY_PROPS = ['data', 'isLoading', 'isError', 'isSuccess'] as const;

/**
 * Extended `notifyOnChangeProps` that also re-renders on `isFetching` changes.
 * Use when a component needs to react to background refetches (e.g. polling, invalidation).
 */
export const QUERY_NOTIFY_PROPS_WITH_FETCHING = [...DEFAULT_QUERY_NOTIFY_PROPS, 'isFetching'] as const;
